import { IconButton, TextField, Typography } from '@mui/material'
import { LabraToolTip } from '@labrav/react-components'
import { InfoOutlined } from '@mui/icons-material'
import { useStyles } from './OfferStakeHolders.styles'
import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { getRandom } from '../../../../../../common/utils/helperFunctions'
import { FormikProps, useFormikContext, FieldArray } from 'formik'
import { PrivateOffer } from '../../../../../../modules/privateOffer/reducer'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { AddUpdateButton } from '@labrav/marketplace'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'
import { get } from 'lodash'

export type OfferStakeHoldersProp = {
  externalBaseURL?: string
}
export const OfferStakeHolders = React.memo(
  ({ externalBaseURL }: OfferStakeHoldersProp) => {
    const { values, errors, touched, handleBlur, handleChange } =
      useFormikContext() as FormikProps<PrivateOffer>
    const { classes } = useStyles()
    const [randomKey, setRandomKey] = useState<number>(getRandom())
    const offerStakeholders = values.offerStakeholders || []

    useEffect(() => {
      setRandomKey(getRandom())
    }, [offerStakeholders.length])

    return (
      <>
        <div
          className={clsx(
            classes.subHeadingContainer,
            classes.companyDetailSubHead
          )}
          style={{ marginTop: '48px' }}
        >
          <Typography
            className={classes.subHeading}
            data-testid="details-subheading-offerStakeholder"
          >
            Offer Stakeholders
          </Typography>
          <LabraToolTip
            tooltipPlacement={'right'}
            label={
              'Enter details of the person from your team who should receive updates of this offer.'
            }
          >
            <InfoOutlined className={classes.infoIcon} />
          </LabraToolTip>
        </div>
        <div
          className={classes.recipientsRowsContainer}
          data-testid="update-recipients"
        >
          <FieldArray name="offerStakeholders">
            {({ push, remove }) => (
              <>
                {offerStakeholders.map((stakeHolders, index) => (
                  <div
                    className={classes.updateRow}
                    data-testid="recipient-row"
                  >
                    <TextField
                      name={`offerStakeholders.${index}.firstName`}
                      label="First name"
                      variant="standard"
                      key={`stakeHolders-${randomKey}-firstName`}
                      value={stakeHolders.firstName}
                      onChange={handleChange}
                      className={classes.textField}
                      error={
                        !!(
                          get(
                            touched,
                            `offerStakeholders.${[index]}.firstName`,
                            false
                          ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.firstName`,
                            false
                          )
                        )
                      }
                      helperText={
                        (!!get(
                          touched,
                          `offerStakeholders.${[index]}.firstName`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.firstName`,
                            ' '
                          )) ||
                        ' '
                      }
                      style={{ width: '30%' }}
                      onBlur={handleBlur}
                      disabled={index === 0 && !externalBaseURL}
                      slotProps={{
                        input: {
                          inputProps: {
                            'data-testid': `offerStakeholders.${index}.firstName`,
                          },
                          disableUnderline: index === 0 && !externalBaseURL,
                        },
                      }}
                    />
                    <TextField
                      name={`offerStakeholders.${index}.lastName`}
                      label="Last name"
                      key={`stakeHolders-${randomKey}-lastName`}
                      variant="standard"
                      value={stakeHolders.lastName}
                      className={classes.textField}
                      onChange={handleChange}
                      error={
                        !!(
                          get(
                            touched,
                            `offerStakeholders.${[index]}.lastName`,
                            false
                          ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.lastName`,
                            false
                          )
                        )
                      }
                      helperText={
                        (!!get(
                          touched,
                          `offerStakeholders.${[index]}.lastName`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.lastName`,
                            ' '
                          )) ||
                        ' '
                      }
                      style={{ width: '30%' }}
                      onBlur={handleBlur}
                      disabled={index === 0 && !externalBaseURL}
                      slotProps={{
                        input: {
                          inputProps: {
                            'data-testid': `offerStakeholders.${index}.lastName`,
                          },
                          disableUnderline: index === 0 && !externalBaseURL,
                        },
                      }}
                    />

                    <TextField
                      name={`offerStakeholders.${index}.email`}
                      label="Email"
                      variant="standard"
                      key={`stakeHolders-${randomKey}-email`}
                      type="email"
                      value={stakeHolders.email}
                      className={classes.textField}
                      onChange={handleChange}
                      error={
                        !!(
                          get(
                            touched,
                            `offerStakeholders.${[index]}.email`,
                            false
                          ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.email`,
                            false
                          )
                        )
                      }
                      helperText={
                        (!!get(
                          touched,
                          `offerStakeholders.${[index]}.email`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerStakeholders.${[index]}.email`,
                            ' '
                          )) ||
                        ' '
                      }
                      style={{ width: '30%' }}
                      onBlur={handleBlur}
                      disabled={index === 0 && !externalBaseURL}
                      slotProps={{
                        input: {
                          inputProps: {
                            'data-testid': `offerStakeholders.${index}.email`,
                          },
                          disableUnderline: index === 0 && !externalBaseURL,
                        },
                      }}
                    />

                    {index > 0 && offerStakeholders.length > 1 ? (
                      <div>
                        <IconButton
                          className={classes.closeIconButton}
                          onClick={() => remove(index)}
                          data-testid="cancel-button"
                          size="large"
                        >
                          <FontAwesomeIcon
                            icon={faCircleXmark}
                            width={'16px'}
                            height={'18px'}
                          />
                        </IconButton>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ))}

                <div
                  className={classes.addButtonContainer}
                  style={{ marginTop: '16px', marginBottom: '34.4px' }}
                >
                  <AddUpdateButton
                    label={'Add offer stakeholder'}
                    onClick={() => {
                      push({
                        email: '',
                        firstName: '',
                        lastName: '',
                      })
                    }}
                    disabled={false}
                    icon={AddCircleOutlineIcon}
                    type={'add'}
                  />
                </div>
              </>
            )}
          </FieldArray>
        </div>
      </>
    )
  }
)
